import { render, staticRenderFns } from "./process-type-du.vue?vue&type=template&id=ba8ba51e&"
import script from "./process-type-du.vue?vue&type=script&lang=js&"
export * from "./process-type-du.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports